"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_id_generator_1 = tslib_1.__importDefault(require("react-id-generator"));

var Button_1 = tslib_1.__importDefault(require("../Buttons/Button"));

var styles = tslib_1.__importStar(require("./ErrorMessage.style"));

var ic_warning_64_x_64_gray_300_svg_1 = tslib_1.__importDefault(require("../../assets/ic-warning-64-x-64-gray-300.svg"));

var ic_empty_64_x_64_gray_300_svg_1 = tslib_1.__importDefault(require("../../assets/ic-empty-64-x-64-gray-300.svg"));

var typeIllust = {
  error: ic_warning_64_x_64_gray_300_svg_1.default,
  empty: ic_empty_64_x_64_gray_300_svg_1.default
};

function ErrorMessage(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'error' : _ref$type,
      title = _ref.title,
      content = _ref.content,
      buttonText = _ref.buttonText,
      illust = _ref.illust,
      onClick = _ref.onClick;

  function handleOnClick() {
    onClick && onClick();
  }

  return jsx_runtime_1.jsxs("div", Object.assign({
    className: className,
    css: styles.container
  }, {
    children: [jsx_runtime_1.jsx("img", {
      css: styles.illust,
      src: illust || typeIllust[type],
      alt: "empty"
    }, void 0), jsx_runtime_1.jsx("div", Object.assign({
      css: styles.title
    }, {
      children: title.split('\\n').map(function (line, index) {
        return jsx_runtime_1.jsx("p", {
          children: line
        }, react_id_generator_1.default());
      })
    }), void 0), jsx_runtime_1.jsx("div", Object.assign({
      css: styles.content
    }, {
      children: children || content && content.split('\\n').map(function (line, index) {
        return jsx_runtime_1.jsx("p", {
          children: line
        }, react_id_generator_1.default());
      })
    }), void 0), buttonText && jsx_runtime_1.jsx(Button_1.default, Object.assign({
      size: "large",
      type: "primary",
      onClick: handleOnClick
    }, {
      children: buttonText
    }), void 0)]
  }), void 0);
}

exports.default = ErrorMessage;